"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var victory_1 = require("victory");
var style = {};
var CardTimeSeries = /** @class */ (function (_super) {
    __extends(CardTimeSeries, _super);
    function CardTimeSeries() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardTimeSeries.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign({}, style, this.props.style) },
            React.createElement(victory_1.VictoryChart, { height: this.props.timeSeriesHeight },
                React.createElement(victory_1.VictoryAxis, { crossAxis: false, style: {
                        tickLabels: { fill: 'none' },
                        axisLabel: { fill: 'none' },
                    }, standalone: false, axisComponent: React.createElement("line", { style: { stroke: 'none' } }), label: 'Date' }),
                React.createElement(victory_1.VictoryAxis, { dependentAxis: true, crossAxis: false, axisComponent: React.createElement("line", { style: { stroke: 'none' } }), style: {
                        grid: { stroke: 'none' },
                        tickLabels: { fill: 'none' },
                    } }),
                React.createElement(victory_1.VictoryLine
                // `data` isn't typed as readonly, hence this cast
                , { 
                    // `data` isn't typed as readonly, hence this cast
                    data: this.props.data, x: 'timestamp', y: 'measure', style: {
                        data: {
                            stroke: 'black',
                            strokeWidth: 1,
                        },
                        labels: { fill: 'none' },
                    } }))));
    };
    return CardTimeSeries;
}(React.PureComponent));
exports.CardTimeSeries = CardTimeSeries;
//# sourceMappingURL=CardTimeSeries.js.map